import useGetExcelNumberFormat from './useGetExcelNumberFormat';

const ListAlphabetExcelFormater = ({ angka }) => {
  const back = useGetExcelNumberFormat(angka);
  return <>{back}</>;
};
export default ListAlphabetExcelFormater;
